import { onlineManager } from '@tanstack/react-query';
import onlineOrderProductRepositoryOfflineAdapters from '../../../modules/offline/offlineRequestAdapters/onlineOrderProduct.repository.offlineAdapters';
import onlineOrderProductRepository from './online.order-product.repository';

const orderProductRepository = (isOfflineMode = false) =>
  isOfflineMode || !onlineManager.isOnline()
    ? onlineOrderProductRepositoryOfflineAdapters()
    : onlineOrderProductRepository();

export default orderProductRepository;
